// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".current-storage[data-v-7451172e] {\n  color: #1c9dd6;\n}\n.menu-label > div[data-v-7451172e]:hover {\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
